import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import ZigButton, { ZigButtonGroup } from '../ZigButton/index.js';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ErrorMessage } from '../../display/ZigAlertMessage/index.js';

var ZigButtonGroupInput = function (_a) {
    var value = _a.value, label = _a.label, error = _a.error, options = _a.options, onChange = _a.onChange, prefixId = _a.prefixId;
    return (React__default.createElement(React__default.Fragment, null,
        typeof label === "string" && (React__default.createElement(Box, { sx: { mb: 1.25 } },
            React__default.createElement(Typography, { variant: "body1", color: "neutral200", id: prefixId && "".concat(prefixId, "__label") }, label))),
        !!label && typeof label !== "string" && label,
        React__default.createElement(ZigButtonGroup, null, options.map(function (o) { return (React__default.createElement(ZigButton, __assign({ id: o.id, onClick: function () { return onChange(o.value); }, key: o.value, active: value === o.value, variant: "outlined" }, (o.extraProps || {})), o.label)); })),
        !!error && (React__default.createElement(Box, { sx: { marginTop: "3px" } },
            React__default.createElement(ErrorMessage, { text: error })))));
};

export { ZigButtonGroupInput as default };
